import rexlaAxios from "./api";
import showSwal from "../utils/showSwal";

export const mintNFT = async () => {
  try {
    const response = await rexlaAxios.post("mintNFT");
    if (response.data && response.data.success === true) {
      return response.data;
    }
    return;
  } catch (err) {
    //showSwal(err.message, "error");
    console.log(err);
    return { success: false };
  }
};

export const checkNFT = async () => {
  try {
    const response = await rexlaAxios.post("checkNFT");
    if (response.data && response.data.success === true) {
      return response.data;
    }
    return;
  } catch (err) {
    showSwal(err.message, "error");
    return;
  }
};
